import { DefaultValues } from "react-hook-form"
import { DEFAULT_NOT_BILLABLE_REASON } from "@/modules/common/billing/components/billing-form/constants"
import { DeBillingSchemaType } from "@/modules/common/billing/components/billing-form/de/schema/de-billing-schema"
import { NotBillableReason } from "@/types/__generated__/union-types"

export const getDeExistingBillingData = (
  billingAttribute: {
    readonly id: string
    readonly isNotBillable: boolean
    readonly isVisualSymptomExamination: boolean | null
    readonly notBillableReason: NotBillableReason | null
    readonly reason: string | null
  } | null,
): DefaultValues<DeBillingSchemaType> | null => {
  return billingAttribute
    ? {
        ...billingAttribute,
        reason: billingAttribute.reason ?? undefined,
        notBillableReason: billingAttribute.notBillableReason ?? DEFAULT_NOT_BILLABLE_REASON,
        isVisualSymptomExamination: billingAttribute.isVisualSymptomExamination ?? false,
      }
    : null
}
